var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarrotsBl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3004",
    "data-name": "Group 3004",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.55,
    height: 54.327,
    viewBox: "0 0 30.55 54.327",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3369",
    "data-name": "Path 3369",
    d: "M2258.21,63.372a3.084,3.084,0,0,1-2.791-1.83,82.01,82.01,0,0,1-6.79-22.207,7.827,7.827,0,0,1,1.027-5.237,6.757,6.757,0,0,1,4.12-3.106l.117-.029h0a18.053,18.053,0,0,1,8.625,0l.119.03a6.76,6.76,0,0,1,4.123,3.107,7.829,7.829,0,0,1,1.027,5.237A82.031,82.031,0,0,1,2261,61.542,3.087,3.087,0,0,1,2258.21,63.372Zm-3.82-30.405-.113.028a5.28,5.28,0,0,0-3.607,6.03,79.922,79.922,0,0,0,6.619,21.641.983.983,0,0,0,1.843,0,79.916,79.916,0,0,0,6.617-21.641,5.279,5.279,0,0,0-3.609-6.03l-.113-.028a15.99,15.99,0,0,0-7.637,0Z",
    transform: "translate(-2242.935 -9.044)",
    fill: "#22294b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line_1011",
    "data-name": "Line 1011",
    d: "M5.391.565H-.468A1.032,1.032,0,0,1-1.5-.468,1.032,1.032,0,0,1-.468-1.5H5.391A1.032,1.032,0,0,1,6.423-.468,1.032,1.032,0,0,1,5.391.565Z",
    transform: "translate(18.18 28.459)",
    fill: "#22294b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Line_1012",
    "data-name": "Line 1012",
    d: "M2.658.565H-.468A1.032,1.032,0,0,1-1.5-.468,1.032,1.032,0,0,1-.468-1.5H2.658A1.032,1.032,0,0,1,3.691-.468,1.032,1.032,0,0,1,2.658.565Z",
    transform: "translate(21.11 31.088)",
    fill: "#22294b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Line_1013",
    "data-name": "Line 1013",
    d: "M5.39.565H-.468A1.032,1.032,0,0,1-1.5-.468,1.032,1.032,0,0,1-.468-1.5H5.39A1.032,1.032,0,0,1,6.423-.468,1.032,1.032,0,0,1,5.39.565Z",
    transform: "translate(9.447 39.857)",
    fill: "#22294b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Line_1014",
    "data-name": "Line 1014",
    d: "M2.658.565H-.468A1.032,1.032,0,0,1-1.5-.468,1.032,1.032,0,0,1-.468-1.5H2.658A1.032,1.032,0,0,1,3.69-.468,1.032,1.032,0,0,1,2.658.565Z",
    transform: "translate(10.118 42.486)",
    fill: "#22294b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3370",
    "data-name": "Path 3370",
    d: "M2245.177,11.257a3.948,3.948,0,0,1,.429.026h.007l.04,0h.011c.088.011.178.025.267.041s.2.038.3.062c.074.017.151.037.232.059l.051.014c2.589.74,5.938,3.265,7.2,11.094a1.032,1.032,0,0,1-1.749.894,3.479,3.479,0,0,0-2.508-1.016c-.071,0-.137,0-.2.005a3.763,3.763,0,0,1-6.73-2.316c0-.06,0-.12,0-.18a4.731,4.731,0,0,1,2.573-8.69Zm.2,2.078a1.917,1.917,0,0,0-.2-.013h0a.466.466,0,0,1-.047,0,2.667,2.667,0,0,0-1.052,5.117,1.032,1.032,0,0,1,.586,1.227,1.7,1.7,0,0,0,3.111,1.3,1.038,1.038,0,0,1,.667-.5,4.83,4.83,0,0,1,1.019-.1,5.739,5.739,0,0,1,1.763.274c-1.011-4.02-2.812-6.491-5.268-7.195l-.035-.009c-.057-.016-.112-.03-.163-.042h0c-.056-.013-.112-.025-.171-.035l-.015,0c-.054-.01-.106-.018-.158-.025Z",
    transform: "translate(-2240.396 -3.064)",
    fill: "#22294b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3371",
    "data-name": "Path 3371",
    d: "M2273.965,11.257h.067a4.731,4.731,0,0,1,2.573,8.69q0,.09,0,.18a3.763,3.763,0,0,1-6.731,2.316c-.059,0-.125-.005-.2-.005a3.476,3.476,0,0,0-2.507,1.016,1.032,1.032,0,0,1-1.75-.894c1.26-7.83,4.609-10.355,7.2-11.095l.049-.013c.08-.022.157-.042.233-.06.1-.024.2-.045.305-.062.088-.016.178-.03.266-.041h.011l.041,0h.005A3.975,3.975,0,0,1,2273.965,11.257Zm0,2.065h0a1.917,1.917,0,0,0-.2.013l-.031,0c-.052.007-.105.015-.158.025l-.015,0c-.058.01-.116.022-.172.035h0c-.051.012-.1.026-.159.041l-.042.011c-2.455.7-4.253,3.175-5.265,7.194a5.751,5.751,0,0,1,1.763-.274,4.811,4.811,0,0,1,1.019.1,1.028,1.028,0,0,1,.666.5,1.7,1.7,0,0,0,3.113-1.3,1.032,1.032,0,0,1,.586-1.227,2.666,2.666,0,0,0-1.052-5.117A.454.454,0,0,1,2273.968,13.322Z",
    transform: "translate(-2248.196 -3.064)",
    fill: "#22294b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3372",
    "data-name": "Path 3372",
    d: "M2251.641,25.215a1.032,1.032,0,0,1-.923-1.491,1.745,1.745,0,0,0,.188-.731,1.545,1.545,0,0,0-.588-1.215,1.032,1.032,0,1,1,1.281-1.619,3.6,3.6,0,0,1,1.372,2.834,3.8,3.8,0,0,1-.4,1.649A1.033,1.033,0,0,1,2251.641,25.215Z",
    transform: "translate(-2243.367 -5.77)",
    fill: "#22294b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3373",
    "data-name": "Path 3373",
    d: "M2266.212,8.482a1.032,1.032,0,0,1-1.032-1.032,3.373,3.373,0,0,0-3.024-3.364,1.033,1.033,0,0,1-.886-.747,2.632,2.632,0,0,0-5.067,0,1.035,1.035,0,0,1-.887.747,3.374,3.374,0,0,0-3.024,3.364,1.032,1.032,0,1,1-2.064,0,5.448,5.448,0,0,1,4.219-5.308,4.748,4.748,0,0,1,1.429-1.815,4.691,4.691,0,0,1,5.721,0,4.747,4.747,0,0,1,1.431,1.815,5.449,5.449,0,0,1,4.217,5.308A1.032,1.032,0,0,1,2266.212,8.482Z",
    transform: "translate(-2243.462 0.647)",
    fill: "#22294b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrotsBl);
export default __webpack_public_path__ + "static/media/Carrots-bl.e73e0f0970c7b74df55a8ef425bb8c56.svg";
export { ForwardRef as ReactComponent };